<div class="global-filter-container">
  <div class="header">
    <span class="heading">Filters</span>
    <i class="pi pi-times" (click)="onClose('close')"></i>
  </div>
  <div class="body">
    <form [formGroup]="globalFilterForm" class="filter-wrapper">
      <div *ngIf="isVisible('selectPeriod')">
        <label class="custom-mat-label">Select Period</label>
        <app-quarter-year-picker
          class="flex mt-2"
          [quarterStartDate]="selectedMasterPlan.iteration_start_date"
          [startQuarter]="currentFilter?.start_quarter"
          [endQuarter]="currentFilter?.end_quarter"
          (yearsSelected)="onYearsSelected($event)"
          [maxYearOptionLimit]="maxYearOptionLimit"
        ></app-quarter-year-picker>
      </div>
      <div *ngIf="isVisible('plant')">
        <label class="custom-mat-label">Plant</label>
        <mat-form-field floatLabel="always">
          <mat-select
            [class.expanded]="filterIconFlag?.['plant_code']"
            ngDefaultControl
            (openedChange)="handleOpenedChange($event, 'plant_code')"
            formControlName="plant_code"
            multiple
            [panelClass]="'global-custom-select'"
            [placeholder]="'Select Plant'"
            [formControl]="manufacturingFilters.plant_code.formControl"
          >
            <mat-option>
              <ngx-mat-select-search
                [formControl]="manufacturingFilters.plant_code.filterCtrl"
                noEntriesFoundLabel="No entries found"
                closeIcon="x"
                placeholderLabel="Search"
              ></ngx-mat-select-search>
            </mat-option>
            <mat-option #allSelectedPlant (click)="toggleAllSelection('plant_code', allSelectedPlant)" [value]="''"> Select All </mat-option>
            <mat-option *ngFor="let plant of manufacturingFilters.plant_code.filtered | async" (click)="togglePerOne('plant_code', allSelectedPlant)" [value]="plant">
              {{ plant.includes('-') ? (plant.split(' - ')[1] ? plant.split(' - ')[1] : plant.split(' - ')[0]) : plant }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div *ngIf="isVisible('line')">
        <label class="custom-mat-label">Line</label>
        <mat-form-field floatLabel="always">
          <mat-select
            [class.expanded]="filterIconFlag?.['line_code']"
            ngDefaultControl
            (openedChange)="handleOpenedChange($event, 'line_code')"
            formControlName="line_code"
            multiple
            [panelClass]="'global-custom-select'"
            placeholder="Select Line"
            [formControl]="manufacturingFilters.line_code.formControl"
          >
            <mat-option>
              <ngx-mat-select-search
                [formControl]="manufacturingFilters.line_code.filterCtrl"
                noEntriesFoundLabel="No entries found"
                closeIcon="x"
                placeholderLabel="Search"
              ></ngx-mat-select-search>
            </mat-option>
            <mat-option #allSelectedLine (click)="toggleAllSelection('line_code', allSelectedLine)" [value]="''"> Select All </mat-option>
            <mat-option *ngFor="let line of manufacturingFilters.line_code.filtered | async" (click)="togglePerOne('line_code', allSelectedLine)" [value]="line">
              {{ line }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div *ngIf="isVisible('productFormat')">
        <label class="custom-mat-label">Process Attribute</label>
        <mat-form-field floatLabel="always">
          <mat-select
            [class.expanded]="filterIconFlag?.['product_format']"
            ngDefaultControl
            (openedChange)="handleOpenedChange($event, 'product_format')"
            formControlName="product_format"
            multiple
            [panelClass]="'global-custom-select'"
            placeholder="Select Process Attribute"
            [formControl]="manufacturingFilters.product_format.formControl"
          >
            <mat-option>
              <ngx-mat-select-search
                [formControl]="manufacturingFilters.product_format.filterCtrl"
                noEntriesFoundLabel="No entries found"
                closeIcon="x"
                placeholderLabel="Search"
              ></ngx-mat-select-search>
            </mat-option>
            <mat-option #allSelectedProdFormat (click)="toggleAllSelection('product_format', allSelectedProdFormat)" [value]="''"> Select All </mat-option>
            <mat-option *ngFor="let type of manufacturingFilters.product_format.filtered | async" (click)="togglePerOne('product_format', allSelectedProdFormat)" [value]="type">
              {{ type }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div *ngIf="isVisible('packFormat')">
        <label class="custom-mat-label">Pack Attribute</label>
        <mat-form-field floatLabel="always">
          <mat-select
            [class.expanded]="filterIconFlag?.['pack_format']"
            ngDefaultControl
            (openedChange)="handleOpenedChange($event, 'pack_format')"
            formControlName="pack_format"
            multiple
            [panelClass]="'global-custom-select'"
            placeholder="Select Pack Attribute"
            [formControl]="manufacturingFilters.pack_format.formControl"
          >
            <mat-option>
              <ngx-mat-select-search
                [formControl]="manufacturingFilters.pack_format.filterCtrl"
                noEntriesFoundLabel="No entries found"
                closeIcon="x"
                placeholderLabel="Search"
              ></ngx-mat-select-search>
            </mat-option>
            <mat-option #allSelectedPackFormat (click)="toggleAllSelection('pack_format', allSelectedPackFormat)" [value]="''"> Select All </mat-option>
            <mat-option *ngFor="let type of manufacturingFilters.pack_format.filtered | async" (click)="togglePerOne('pack_format', allSelectedPackFormat)" [value]="type">
              {{ type }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </form>
  </div>
  <div class="footer">
    <button class="btn mdlz-btn" (click)="applyFilters()">Apply</button>
    <button class="btn mdlz-btn-outline" (click)="onClose('clear')">Clear</button>
  </div>
</div>
